import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl, NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { IonInput, LoadingController } from '@ionic/angular';
import { CommonService } from 'src/app/services/common.service';
import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'app-otpverification',
  templateUrl: './otpverification.page.html',
  styleUrls: ['./otpverification.page.scss'],
})
export class OtpverificationPage implements OnInit {

  @ViewChild('otpInput', { static: false }) otpInput: IonInput;

  verificationForm: FormGroup;
  submitted: boolean = false;
  qrString: string = null
  verificationCode: any  = null

  verificationLinkSend: boolean = false


  controlStatus: any = {
    otpCode: false
  };


  constructor(
    private router: Router,
    public loadingController: LoadingController,
    public _commonService: CommonService,
    private _apiService: ApiService,
    private formBuilder: FormBuilder,
    private _authService: AuthService,
    public _translationService: TranslationService) { }

  ngOnInit() {
    this.verificationForm = this.formBuilder.group({
      otpCode: ['', [Validators.required, Validators.pattern(this._commonService.otpCodePattern)]]
    }
    );
    
  }

  ionViewWillEnter(){
    if (!this._commonService.tempUserName) {
      this.router.navigate(['/login'], { replaceUrl: true });
    }
  }

  ionViewDidEnter() {
    if(localStorage.isFromInviteUser && (JSON.parse(localStorage.isFromInviteUser) == true)){
      this._commonService.showQrScanner = false
    }
    this.verificationLinkSend = false
    if (this.verificationForm) this.verificationForm.enable();
    this.qrString = 'otpauth://totp/' + this._commonService.tempUserName + '?secret=' + this._commonService.secretKey + '&issuer=brandmr'
    setTimeout(() => {
      this.otpInput.setFocus();
    }, 200); 
  }

  onReset() {
    this.submitted = false;
    this._commonService.tempUserName = null;
    this._commonService.tempDomainName = null;
    this.verificationForm.reset();
  }

  ionViewDidLeave() {
    if(localStorage.isFromInviteUser){
      localStorage.removeItem('isFromInviteUser')
    }
    this.onReset();
  }  

  get f() { return this.verificationForm.controls; }

  async onSubmit() {
    this.submitted = true;
    // this.verificationForm.disable();
    // if (this.verificationForm.invalid) {
    //   return;
    // }
    this._commonService.presentLoading();
    try {
      let data = {
        "userName": this._commonService.tempUserName,
        "otpCode": this.verificationForm.value.otpCode,
        "localeCode": (localStorage.locale && !Number.isNaN(Number(localStorage.locale))) ? localStorage.locale : 1043
      }
      this._authService.doVerifyPassCode(data, 'Login/VerifyPassCode', localStorage.otpAuthenticationKey).subscribe( async (res) => {
        this._commonService.tempUserName = null;
        this._commonService.tempDomainName = null;


        let currentTime = new Date();
        localStorage.sessionStartTime = currentTime.getHours();
        localStorage.setItem('userId', res.body.UserId);
        localStorage.setItem('userName', res.body.UserName);
        localStorage.setItem('firstName', res.body.FirstName);
        localStorage.setItem('domainLocales', JSON.stringify(res.body.Locales));
        localStorage.setItem('menuItems', JSON.stringify(res.body.MenuItems));
        localStorage.setItem('domainName', res.body.DomainName);
        localStorage.setItem('domainId', res.body.DomainId);
        localStorage.setItem('roleCode', res.body.RoleCode);
        localStorage.setItem('authenticationKey', res.body.AuthenticationKey);
        localStorage.setItem('MaxAllowedCompanyPerDomain', res.body.MaxAllowedCompanyPerDomain);
        localStorage.setItem('notificationsUnreadCount', res.body.NotificationsUnreadCount ? res.body.NotificationsUnreadCount : 0);
        localStorage.setItem('Datecreated', res.body.Datecreated ? res.body.Datecreated : '');
        localStorage.setItem('FirstLogin', res.body.FirstLogin ? res.body.FirstLogin : 'false');
        localStorage.setItem('DomainSubscriptionContactNumber', res.body.DomainSubscriptionContactNumber ? res.body.DomainSubscriptionContactNumber : '');
        localStorage.setItem('TeamLeaderGuid',res.body.TeamLeaderGuid);
        localStorage.setItem('locale',res.body.DefaultLocale?res.body.DefaultLocale:1043);
        
        this._commonService.phoneNumber = res.body.DomainSubscriptionContactNumber ? res.body.DomainSubscriptionContactNumber : ''
        
        this._commonService.notificationsUnreadCount = res.body.NotificationsUnreadCount ? res.body.NotificationsUnreadCount : 0
        if (res.body.Logo) {
          this._commonService.logo = 'data:image/png;base64,' + res.body.Logo;
          localStorage.setItem('Logo', 'data:image/png;base64,' + res.body.Logo);
        } else {
          this._commonService.logo = null;
          localStorage.removeItem('Logo');
        }

        if (res.body.CustomerLogo) {
          this._commonService.customerLogo = 'data:image/png;base64,' + res.body.CustomerLogo;
          localStorage.setItem('customerLogo', 'data:image/png;base64,' + res.body.CustomerLogo);
        } else {
          this._commonService.customerLogo = null;
          localStorage.removeItem('customerLogo');
        }


        this._commonService.linkedToMultipleDomains = res.body.LinkedToMultipleDomains
        if(res.body.RoleCode == 'UserRole_CustomerAdmin'){
          this._commonService.isCustomerAdmin = true
        }

        if(res.body.RoleCode == 'UserRole_CustomerUser'){
          this._commonService.isCustomerUser = true
        }

        if(res.body.RoleCode == 'UserRole_Support'){
          this._commonService.isSupportUser = true
        }
        if(res.body.RoleCode  == 'UserRole_Legal'){
          this._commonService.isJuristUser = true
        }
        
      
        localStorage.setItem('userRoles', res.body.UserRoles ? JSON.stringify(res.body.UserRoles) : null);
        localStorage.removeItem('otpAuthenticationKey');
        this._translationService.getTranslation(localStorage.locale ? localStorage.locale : 1043);
      

        this._commonService.domainLocales = res.body.Locales;

        if (res.body.Locales.length == 1) {
          this._commonService.locale = res.body.Locales[0].LocaleId;
          localStorage.locale = res.body.Locales[0].LocaleId;
        }

        localStorage.locale = res.body.DefaultLocale
        this._commonService.locale = res.body.DefaultLocale
        
        this._commonService.menuItems = res.body.MenuItems;
        this._commonService.domainName = res.body.DomainName;

        this._commonService.domain = {
          DomainId: res.body.DomainId,
          Name: res.body.DomainName
        }

        if(localStorage.currentImage){
          localStorage.removeItem('currentImage')
        }

        if(localStorage.helpDetail){
          localStorage.removeItem('helpDetail')
        }
      
       
        this._commonService.dismiss();

    



        if (this._commonService.redirectURL) {
          let url = this._commonService.redirectURL.split('/');
          this._commonService.redirectURL = null;
          this.router.navigate(['documentlibrary/' + url[2] + '/' + url[3] + '/' + url[4]]);
        }
        else if (res.body.RoleCode == 'UserRole_Administrator') {
          this.router.navigate(['/maintenance']);
          this._commonService.isAdmin = true
          this._commonService.redirectURL = null;
        }
        else {this.router.navigate(['/dashboard'], {replaceUrl: true})
        this._commonService.redirectURL = null;
        }
        
        this._commonService.isLoggedIn = true;

        this._commonService.getNotificationCount();
        // if (res.body.RoleCode != 'UserRole_Contractor' && res.body.RoleCode != 'UserRole_Customer') {
        //   if (res.body.RoleCode != 'UserRole_Auditor') {
        //     this._commonService.getScheduleIntervals();
        //   }
        //   this._commonService.getObjectTypes();
        // }
        // this._commonService.getCompanies();
        // this._commonService.getObjectGroups();
        // if (res.body.RoleCode != 'UserRole_Auditor') {
        //   this._commonService.getTempalteFoldersTree();
        // }
        // this._commonService.getObjects();
        this._commonService.getFAQS()
        localStorage.domains = res.body.LinkedDomains ? JSON.stringify(res.body.LinkedDomains) : null;
        try{
          let moduleList = await this._apiService.getModules('', '', '', 1, 0);
          localStorage.moduleList = JSON.stringify(moduleList);

        }catch(error){
            this._commonService.dismiss();
            this._commonService.log(error, this._commonService.ERROR);
        }
        try{
          let moduleList = await this._apiService.getModules('', '', '', 1, 0);
          localStorage.moduleList = JSON.stringify(moduleList.body);

        }catch(error){
            this._commonService.dismiss();
            this._commonService.log(error, this._commonService.ERROR);
        }


        try {
          let settingList = await this._apiService.getSettings('', '', '', 1, 0);
          settingList.body.forEach((value, index) => {
            if (value.SettingName == "Force2FactorAuthentication") {
              localStorage.Force2FactorAuthentication = value.SettingValue;
            }
            if (value.SettingName == "TeamleaderTags") {
              localStorage.TeamleaderTags = value.SettingValue;
            }
          })
        } catch (error) {
          this._commonService.dismiss();
          this._commonService.log(error, this._commonService.ERROR);
        }
      } ,(err) => {
        this.verificationForm.get('otpCode').setValue('');
        this._commonService.log(err, this._commonService.ERROR);
        this._commonService.dismiss();
      } );
    }
    catch (error) {
      this._commonService.log(error, this._commonService.ERROR);
      this._commonService.dismiss();
    }
  }

  gotoLogin(){
    this.router.navigate(['/login'], { replaceUrl: true });
    this.verificationLinkSend = false;
  }

  async setupAuthentication(){
    this._commonService.presentLoading();
    try {
      let data = {
        "userName": this._commonService.tempUserName,
        "localeCode": (localStorage.locale && !Number.isNaN(Number(localStorage.locale))) ? localStorage.locale : 1043
      }
      let response = await this._apiService.verify2faLinkedSend(data);
      this.verificationLinkSend = true;
      this._commonService.dismiss();

    } catch (error) {
      this._commonService.log(error, this._commonService.ERROR);
      this._commonService.dismiss();
    }
  }

  onBlurMethod(controlName){
  if(controlName == 'otpCode'){
    this.controlStatus.otpCode = true
  }
   }
 
   onFocusMethod(controlName){
  if(controlName == 'otpCode'){
    this.controlStatus.otpCode = false
  }

   }

  //  onInputChange(event){
  //   if(this.verificationForm.value.otpCode != '' && this.verificationForm.valid){
  //     this.onSubmit()
  //   }

  //  }

   // Called on every input change
  onOtpInputChange(event: any) {
    const otpCode = event.detail.value;

    if (otpCode.length === 6) {
      // Automatically submit once 6 digits are entered
      this.onSubmit();
    }
  }

}
